var map = {
	"./Don_Luigi_Fraccari.jpg": 1697,
	"./Foto-Haus-Pius.jpg": 2235,
	"./Geocaching.png": 4284,
	"./Todesanzeige_Fraccari.jpg": 3241,
	"./bueste.jpg": 1528,
	"./home.jpg": 350,
	"./pius-title.png": 8042
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8583;